import { Box } from '@mui/material';
import OtpInput from 'react-otp-input';

interface OtpFieldProps {
  otp: string;
  dataTestid: string;
  setOtp: (value: string) => void;
}
export const OtpField = (props: OtpFieldProps) => {
  const sanitizeOtp = (value: string) => {
    //this rejects pasted input if it contains anything other than numbers
    const isBadInput = /[^0-9]/g.test(value);
    if (!isBadInput) {
      props.setOtp(value);
    } else {
      props.setOtp('');
    }
  };
  return (
    <OtpInput
      numInputs={6}
      value={props.otp}
      onChange={sanitizeOtp}
      isInputNum={true}
      containerStyle={{
        marginTop: 20,
      }}
      separator={
        <Box
          sx={{
            width: 60,
          }}
        ></Box>
      }
      inputStyle={{
        width: 40,
        height: 60,
        fontSize: 16,
        fontWeight: 400,
        borderRadius: 4,
        color: 'black',
        border: '1px solid #307fe2',
      }}
      focusStyle={{
        outlineColor: '#307fe2',
      }}
      data-testid={props.dataTestid}
    />
  );
};
